















import { computed, defineComponent, PropType } from '@vue/composition-api';
import SelectBox from './SelectBox.vue';
import {
	MonthOption,
	ApiMonthOption,
	MONTH_NUMBER_FOR_KEY,
	DEFAULT_VALUE,
	MONTH_OPTIONS_AS_NUMBERS,
	API_NUMBERS_TO_MONTH_OPTION,
	isApiMonthOption,
} from './monthPickerUtil';

const ORDERED_KEYS = [
	MonthOption.NONE,
	MonthOption.JAN,
	MonthOption.FEB,
	MonthOption.MAR,
	MonthOption.APR,
	MonthOption.MAY,
	MonthOption.JUN,
	MonthOption.JUL,
	MonthOption.AUG,
	MonthOption.SEP,
	MonthOption.OCT,
	MonthOption.NOV,
	MonthOption.DEC,
];

export default defineComponent({
	components: { SelectBox },
	props: {
		value: {
			type: [String, Number] as PropType<ApiMonthOption | MonthOption>,
			default: DEFAULT_VALUE,
		},
		/**
		 * By default this will emit results from the MonthOption enum
		 * but in some cases we prefer to get numbers defined by the
		 * MONTH_OPTIONS_AS_NUMBERS object for some APIs
		 */
		asNumbers: Boolean,
		isFullWidth: Boolean,
	},
	setup(props, ctx) {
		const computedValue = computed(() => {
			const val = props.value;
			if (props.asNumbers) {
				if (!isApiMonthOption(val)) {
					return MonthOption.NONE;
				}
				return API_NUMBERS_TO_MONTH_OPTION[val];
			}
			return val;
		});
		const getLabelForKey = (key: MonthOption) => {
			if (key === MonthOption.NONE) {
				return ctx.root.$t('month-picker.none');
			}
			return ctx.root.$d(new Date(0, MONTH_NUMBER_FOR_KEY[key]), 'month');
		};
		const selectOptions = computed(() => ORDERED_KEYS
			.map((key) => ({
				key,
				label: getLabelForKey(key),
			})));
		const emitValue = (evt: MonthOption) => {
			const val = props.asNumbers ? MONTH_OPTIONS_AS_NUMBERS[evt] : evt;
			ctx.emit('input', val);
		};
		return {
			computedValue,
			selectOptions,
			noneOption: MonthOption.NONE,
			getLabelForKey,
			emitValue,
		};
	},
});
